import request from '@/utils/request'
const apiPath = '/course/courseTopic'
import { downloadBlob } from '@/utils/download'
const courseTopicApi = {
  /**
   * 新增【课程题目】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【课程题目】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【课程题目】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查看【课程题目】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【课程题目】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  batchState(data) {
    return request.post(apiPath + '/batchState', data, {isFormData: 1})
  },
  exportExcel(query) {
    return request.get(`${apiPath}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '课程题目.xlsx'))
  },
  exportExcel2(query) {
    return request.get(apiPath + '/exportExcel2', { params: query })
  },
  courseImport(data) {
    return request.post(apiPath + '/importExcel2', data)
  },
  downloadExcelTemplate2(query) {
    return request.get(`${apiPath}/downloadExcelTemplate2`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '课程题目模板.xlsx'))
  },
}
export default courseTopicApi
